import React, { useState, useEffect, useRef } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { auth, provider, Tprovider } from "../../firebase";
import { format } from "date-fns";
import {
  GoogleLoginButton,
  TwitterLoginButton,
} from "react-social-login-buttons";
import axios from "axios";
// import Button from "react-bootstrap/Button";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./SignUp.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { z, ZodType } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";
import { BsEmojiFrown } from "react-icons/bs";
import { baseUrl, GetToken, getUserCountry } from "../../App";
import { IUserDetails, Referrals } from "../EnrollTypes";
type FormData = {
  firstname: string;
  email: string;
  lastname: string;
  password: string;
  password2: string;
};

export const validateReferralLink = async (
  inviteCode: string | null,
  name: string,
  email: string
): Promise<boolean> => {
  let idToken = await GetToken();
  const body = {
    ReferralId: inviteCode,
  };
  const referrerResponse = await axios
    .post(`${baseUrl}/getusersbyfield`, body, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    })
    .catch((error) => {
      if (
        error.response.data.code === 404 ||
        error.response.data.status === "No matching docs"
      ) {
        console.log("No matching account with this invite code");
      } else {
        console.log(error.response.data);
      }
    });
  let doyen: IUserDetails = referrerResponse?.data?.data[0];
  if (doyen) {
    const referrerBody = {
      ReferrerEmail: doyen?.email,
      ReferrerId: doyen?.ReferralId,
      ReferrerName: doyen?.firstname + " " + doyen?.lastname,
      ReferrerStatus: doyen?.UserStatus,
      Referrals: [
        {
          CoursePaidFor: "",
          CurrencyOfCoursePaidFor: "",
          DateRegistered: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
          DateSignedUp: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
          EarningsLabel: "No Earnings",
          Email: email,
          Name: name,
          PriceOfCoursePaidFor: 0,
          ReferralStatus: "Registered",
        },
      ],
    };
    await axios
      .post(`${baseUrl}/referrers`, referrerBody, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      })
      .catch((error) => {
        if (
          error?.response?.data?.code === 409 ||
          error?.response?.data?.status === "Existing Account"
        ) {
          let referrals: Referrals[] =
            error?.response?.data?.data[0]?.Referrals;
          const referrer_id = error?.response?.data?.data[0]?.Id;
          let referralAlreadyCreated = 0;
          referrals.forEach((referral: Referrals) => {
            if (referral.Name === name || referral.Email === email) {
              referralAlreadyCreated += 1;
            }
          });
          if (referralAlreadyCreated !== 0) {
            return false;
          } else {
            const bodyReferrals = {
              Referrals: [
                ...referrals,
                {
                  CoursePaidFor: "",
                  CurrencyOfCoursePaidFor: "",
                  DateRegistered: format(
                    new Date(),
                    "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
                  ),
                  DateSignedUp: format(
                    new Date(),
                    "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
                  ),
                  EarningsLabel: "No Earnings",
                  Email: email,
                  Name: name,
                  PriceOfCoursePaidFor: 0,
                  ReferralStatus: "Registered",
                },
              ],
            };
            axios
              .patch(`${baseUrl}/referrers/` + referrer_id, bodyReferrals, {
                headers: {
                  Authorization: `Bearer ${idToken}`,
                },
              })
              .catch((error) => {
                console.log(error.response.data);
              });
          }
        } else {
          console.log(error.response.data);
          return false;
        }
      });
    return true;
  }
  return false;
};

const SignUp = () => {
  const [password, setPassword] = useState("");
  const [inputemail, setInputemail] = useState("");
  const [inputphone, setInputphone] = useState("");
  const [inputlastname, setInputlastname] = useState("");
  const [inputfirstname, setInputfirstname] = useState("");
  const [inputMonth, setInputMonth] = useState("");
  const [inputDay, setInputDay] = useState("");
  const [showTooltip, setshowTooltip] = useState(false);
  const [nophoneerror, setNophoneerror] = useState(true);
  const [studentdetails, setStudentdetails] = useState<any>({});
  const [gphone, setGphone] = useState("");
  const [medium, setMedium] = useState("");
  const [password2, setPassword2] = useState("");
  const [geterror, setGeterror] = useState("");
  const [geterror2, setGeterror2] = useState("");
  const moveGoogle = true;
  const [nophoneerror2, setNophoneerror2] = useState(true);
  const [givefullview, setGivefullview] = useState(false);
  const [shownote, setShownote] = useState(false);
  const [notific, setNotific] = useState("");
  const [goodnote, setGoodnote] = useState(false);
  const [hidepassword, setHidepassword] = useState(true);
  const [hidepassword2, setHidepassword2] = useState(true);
  const [todisable, setTodisable] = useState(false);
  const hideloginform = false;
  const [showLoginbtn, setShowLoginbtn] = useState(false);
  const ifGoogle = false;
  const ifTwitter = false;
  const [twitterFirstname, setTwitterFirstname] = useState("");
  const [twitterLastname, setTwitterLastname] = useState("");
  const [twitterPhone, setTwitterPhone] = useState("");
  const [twitterEmail, setTwitterEmail] = useState("");
  const [twitternofirstnameerror, setTwitternofirstnameerror] = useState(true);
  const [twitternolastnameerror, setTwitternolastnameerror] = useState(true);
  const [twitternoemailerror, setTwitternoemailerror] = useState(true);
  const [twitternophoneerror, setTwitternophoneerror] = useState(true);
  const [showTwitterLogin, setShowTwitterLogin] = useState(false);
  const hideTwitterSignup = false;
  const hideSocialSignup = false;
  const [newsLetter, setNewsLetter] = useState(false);
  const [tracker, setTracker] = useState(0);

  var count = useRef(0);
  let navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notification, setNotification] = useState("");

  // Function to get error message based on error type

  const getErrorMessage = (error: any) => {
    if (!error.response) {
      return "Network Error: Unable to connect to the server. Please check your internet connection.";
    }
    const statusCode = error.response.status;
    switch (statusCode) {
      case 500:
        return "Oops, there is a slight issue with our server, please refresh or try again in a moment.";
      case 400:
        return "Sorry, our server cannot process your input. Please confirm your input.";
      case 403:
        return "You do not have permission to access this resource.";
      case 404:
        return "Your requested resource could not be found on the server.";
      default:
        return `Error ${statusCode}: An error occurred. Please try again later.`;
    }
  };

  function handleSignInError(error: any) {
    switch (error.code) {
      case "auth/invalid-email":
        setShowNotification(true);
        setNotification("Invalid email address. Please try again.");
        break;
      case "auth/email-already-in-use":
        setShowNotification(true);
        setNotification(
          "Email Address already exists, please proceed to log in."
        );
        break;
      case "auth/user-disabled":
        setShowNotification(true);
        setNotification("This user account has been disabled.");
        break;
      case "auth/user-not-found":
        setShowNotification(true);
        setNotification("User not found. please signup or try again.");
        break;
      case "auth/wrong-password":
        setShowNotification(true);
        setNotification("Incorrect Password. Please try again.");
        break;
      case "auth/invalid-credential":
        setShowNotification(true);
        setNotification("Invalid/Incorrect login details. Please try again.");
        break;
      default:
        setShowNotification(true);
        setNotification("An unknown error occurred. Please try again later.");
    }
  }
  const handleModalClose = () => {
    setShowModal(false);
    setModalContent(""); // Reset modal content
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  const subscribetonewsletter = () => {
    setNewsLetter(!newsLetter);
  };

  const getTwitterSignupdata = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (twitterFirstname.length < 1) {
      setTwitternofirstnameerror(false);
    } else {
      setTwitternofirstnameerror(true);
    }

    if (twitterLastname.length < 1) {
      setTwitternolastnameerror(false);
    } else {
      setTwitternolastnameerror(true);
    }

    if (twitterEmail.length < 1) {
      setTwitternoemailerror(false);
    } else {
      setTwitternoemailerror(true);
    }

    if (inputphone.length < 6) {
      setTwitternophoneerror(false);
    } else {
      setTwitternophoneerror(true);
    }

    if (
      twitterFirstname.length > 1 &&
      twitterLastname.length > 1 &&
      twitterEmail.length > 1 &&
      twitterPhone.length > 6
    ) {
      setTwitternofirstnameerror(true);
      setTwitternolastnameerror(true);
      setTwitternoemailerror(true);
      setTwitternophoneerror(true);
      setShowTwitterLogin(true);
    }
  };

  const todoyen2page = () => {
    setShowLoginbtn(true);
  };

  const myHandleTwitter = async () => {
    //console.log("Within myHandleTwitter")
    const urlParams = new URLSearchParams(window.location.search);
    const inviteCode = urlParams.get("invite");
    const userDetails = await getUserCountry();
    if (tracker === 0) {
      //console.log("Tracker is "+tracker)
      await signInWithPopup(auth, Tprovider).then((data: any) => {
        const userBody = {
          firstname: data?.user?.displayName?.split(" ")[0],
          lastname: data?.user?.displayName?.split(" ").slice(1).join(" "),
          email: data?._tokenResponse?.email || "",
          phone: data?._tokenResponse?.phoneNumber || "",
          sourceOfDiscovery: "Website",
          newLetter: "false",
          uids: data?.user?.uid,
          Country: userDetails?.countryName,
          showEmail: true,
          inviteCode: inviteCode,
        };
        setTracker(1);
        navigate("/complete-social-logins", { state: userBody });
      });
    }
  };

  useEffect(() => {
  // Clear any autofilled values on mount
  const inputs = document.querySelectorAll("input");
  inputs.forEach((input) => (input.value = ""));
}, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setGivefullview(true);
  }, []);

  const toSignIn = () => {
    navigate("/signin");
  };

  // const tohomepage = () => {
  //   navigate("/signin");
  // };

  const submittoapi = async (studentdetails2: any) => {
    let idToken = await GetToken();
    let referred = false;
    const urlParams = new URLSearchParams(window.location.search);
    const inviteCode = urlParams.get("invite");
    if (inviteCode) {
      referred = await validateReferralLink(
        inviteCode,
        studentdetails2.firstname.trim() +
          " " +
          studentdetails2.lastname.trim(),
        studentdetails2.email.trim()
      );
    }

    const userDetails = await getUserCountry();

    const bodyFormData = {
      firstname: studentdetails2.firstname.trim(),
      lastname: studentdetails2.lastname.trim(),
      email: studentdetails2.email.trim(),
      DOB: inputDay + "-" + inputMonth,
      phone: studentdetails2.phone.trim(),
      sourceOfDiscovery: studentdetails2.sourceOfDiscovery.trim(),
      newLetter: String(newsLetter).trim(),
      uids: " ",
      Country: userDetails.countryName,
      Referred: referred,
    };

    const bodyFormData2 = {
      sender: {
        name: "Doyenify Academy",
        email: "info@doyenify.com",
      },
      to: [
        {
          email: studentdetails2.email,
        },
      ],
      replyTo:{
        email:"info.doyenify@gmail.com",
      },
      subject: "You have successfully registered to Doyenify Academy",
      htmlContent: `<html><head>

            <style>
                body {
                    background-color:#696969;
                }
                .imgtag{
                    justify-content: center;
                    align-items: center;
                    margin-left: 45%;
                }
                .welcome {
                    text-align: center;
                    color: #696969;
                }
        
                .content {
                    background-color: #ffffff;
                    margin: 15px;
                    padding: 20px;
                }
            </style>
        </head>
        
        <body>
            <div class="imgtag">
                <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
            </div>
                
            <div class="content">
                <h2 class="welcome">{{params.username}}, Welcome to Doyenify Academy</h2>
                
                <p>Dear {{params.username}},</p>
                <p>Welcome to <a href="https://academy.doyenify.com" >Doyenify Academy</a>.! We are excited to have you as a part of our community. Get ready for a fantastic journey filled with Hands-On Practical Experience</p>
                <p>Here's a quick overview of what you can expect:
                <ol type="1">
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Expert-Led Learning:</span> <p>Our courses are led by experienced industry professionals who bring their real-world insights and expertise into the classroom, giving you practical knowledge that is immediately applicable. </p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Hands-On Projects:</span> <p>We emphasize learning by doing. Throughout the courses, you will work on a series of hands-on projects, building a robust portfolio that showcases your skills to potential employers.</p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Job-Ready Skills:</span> <p>Our curriculum is carefully crafted to match the skills demanded by the job market. By the time you graduate, you will possess the coding and problem-solving abilities that employers are looking for.</p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Problem-Solving Focus:</span> <p> Coding is about more than just syntax; it is about finding innovative solutions. Our bootcamp hones your ability to approach complex problems creatively and analytically.</p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Results-Driven Approach:</span> <p>Our success is measured by your success. We are dedicated to helping you achieve your career goals and providing you with the skills to excel in the tech industry.</p>
                    </li>
                </ol>
                
                <p>We are thrilled to embark on this journey with you. If you have any questions, feedback, or suggestions, do not hesitate to reach out to us at info@doyenify.com or +372 5670 4920. Remember, your experience and satisfaction are our top priorities.</p>
                <p>Thank you for choosing <a href="https://academy.doyenify.com" >Doyenify Academy</a>. Let's help you achieve your Tech dreams!</p>
                <p>Best regards,</p>
                <p>DoyenifyAcademy</p>
        
            </div>
        
            
        </body>
        </html>
                            `,
      params: {
        username: studentdetails2.firstname,
      },
    };

    const bodyFormData3 = {
      sender: {
        name: "Doyenify Academy Notification",
        email: "info@doyenify.com",
      },
      to: [
        {
          email: "info.doyenify@gmail.com",
        },
      ],
      replyTo:{
        email:"info.doyenify@gmail.com",
      },
      subject: "Newly Registered User",
      htmlContent: `<html><head></head><body>
                            <h1>you have a newly registered user</h1>
                            <p>student with Name: {{params.username}}, registered</p>
                            <p>User Phone is: {{params.userphone}}</p>
                            <p>User Email is: {{params.useremail}}</p>
                        </body></html>`,
      params: {
        useremail: studentdetails2.email,
        username: studentdetails2.firstname + " " + studentdetails2.lastname,
        userphone: studentdetails2.phone,
      },
    };
    await axios
      .post(`${baseUrl}/registration`, bodyFormData, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      })
      .then(async () => {
        // setGoodnote(true);
        count.current = 0;
        // setShownote(true);
        const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
          process.env.REACT_APP_SERVICE_KEY, {
          method: "post",
          body: JSON.stringify({
            email: process.env.REACT_APP_SERVICE_EMAIL,
            password: process.env.REACT_APP_SERVICE_PASSWORD,
            returnSecureToken: true,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const userToken = await responseToken.json();
        await axios
        .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyFormData2, {
            headers: { Authorization: `Bearer ${userToken.idToken}` },
          }
        )
        .then()
        .catch(() => {
          console.log("(axios) an error occurred")
        });

         await axios
        .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyFormData3, {
            headers: { Authorization: `Bearer ${userToken.idToken}` },
          }
        )
        .then()
        .catch(() => {
          console.log("(axios) an error occurred")
        });
           
        localStorage.setItem("userEmail", studentdetails2.email);
        let APIRequest = {
          Email: studentdetails2.email,
        };
        await axios.post(`${baseUrl}/sendVerificationCode`, APIRequest, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        });
        setInputemail("");
        setInputphone("");
        setInputlastname("");
        setInputfirstname("");
        setInputemail("");
        setPassword("");
        setPassword2("");
        setGeterror("");
        navigate("/useraction", {
          state: { userEmail: studentdetails2.email },
        });
        // setTimeout(toSignIn, 2000);
      })
      .catch((error) => {
        console.log(error);
        setShowModal(true);
        setModalContent("Unable to create your account. Please try again!");
        // if (auth.currentUser) {
        //   auth.currentUser.delete();
        // }
      });
  };

  const submittoapi2 = async (studentdetails2: any) => {
    let idToken = await GetToken();
    const userDetails = await getUserCountry();
    var medd = "";
    if (studentdetails2.sourceOfDiscovery.length === 0) {
      medd = "others";
    }

    if (studentdetails2.sourceOfDiscovery.length > 0) {
      medd = studentdetails2.sourceOfDiscovery;
    }
    const bodyFormData = {
      firstname: studentdetails2.firstname.trim(),
      lastname: studentdetails2.lastname.trim(),
      email: studentdetails2.email.trim(),
      phone: gphone.trim(),
      sourceOfDiscovery: medd.trim(),
      newLetter: String(newsLetter).trim(),
      uids: "null",
      Country: userDetails.countryName.trim(),
    };

    const bodyFormData2 = {
      sender: {
        name: "Doyenify Academy",
        email: "info@doyenify.com",
      },
      to: [
        {
          email: studentdetails2.email,
        },
      ],
      replyTo:{
        email:"info.doyenify@gmail.com",
      },
      subject: "You have successfully registered to Doyenify Academy",
      htmlContent: `<html><head>

            <style>
                body {
                    background-color:#696969;
                }
                .imgtag{
                    justify-content: center;
                    align-items: center;
                    margin-left: 45%;
                }
                .welcome {
                    text-align: center;
                    color: #696969;
                }
        
                .content {
                    background-color: #ffffff;
                    margin: 15px;
                    padding: 20px;
                }
            </style>
        </head>
        
        <body>
            <div class="imgtag">
                <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
            </div>
                
            <div class="content">
                <h2 class="welcome">{{params.username}}, Welcome to Doyenify Academy</h2>
                
                <p>Dear {{params.username}},</p>
                <p>Welcome to <a href="https://academy.doyenify.com" >Doyenify Academy</a>.! We are excited to have you as a part of our community. Get ready for a fantastic journey filled with Hands-On Practical Experience</p>
                <p>Here's a quick overview of what you can expect:
                <ol type="1">
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Expert-Led Learning:</span> <p>Our courses are led by experienced industry professionals who bring their real-world insights and expertise into the classroom, giving you practical knowledge that is immediately applicable. </p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Hands-On Projects:</span> <p>We emphasize learning by doing. Throughout the courses, you will work on a series of hands-on projects, building a robust portfolio that showcases your skills to potential employers.</p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Job-Ready Skills:</span> <p>Our curriculum is carefully crafted to match the skills demanded by the job market. By the time you graduate, you will possess the coding and problem-solving abilities that employers are looking for.</p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Problem-Solving Focus:</span> <p> Coding is about more than just syntax; it is about finding innovative solutions. Our bootcamp hones your ability to approach complex problems creatively and analytically.</p>
                    </li>
                    <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Results-Driven Approach:</span> <p>Our success is measured by your success. We are dedicated to helping you achieve your career goals and providing you with the skills to excel in the tech industry.</p>
                    </li>
                </ol>
                
                <p>We are thrilled to embark on this journey with you. If you have any questions, feedback, or suggestions, do not hesitate to reach out to us at info@doyenify.com or +372 5670 4920. Remember, your experience and satisfaction are our top priorities.</p>
                <p>Thank you for choosing <a href="https://academy.doyenify.com" >Doyenify Academy</a>. Let's help you achieve your Tech dreams!</p>
                <p>Best regards,</p>
                <p>DoyenifyAcademy</p>
        
            </div>
        
            
        </body>
        </html>
                            
                        `,
      params: {
        username: studentdetails2.firstname,
      },
    };

    const bodyFormData3 = {
      sender: {
        name: "Doyenify Academy Notification",
        email: "info@doyenify.com",
      },
      to: [
        {
          email: "info.doyenify@gmail.com",
        },
      ],
      replyTo:{
        email:"info.doyenify@gmail.com",
      },
      subject: "Newly Registered User",
      htmlContent: `<html><head></head><body>
                            <h1>you have a newly registered user</h1>
                            <p>student with Name: {{params.username}}, registered</p>
                            <p>User Phone is: {{params.userphone}}</p>
                            <p>User Email is: {{params.useremail}}</p>
                        </body></html>`,
      params: {
        useremail: studentdetails2.email,
        username: studentdetails2.firstname + " " + studentdetails2.lastname,
        userphone: gphone,
      },
    };

    await axios
      .post(`${baseUrl}/registration`, bodyFormData, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      })
      .then(async() => {
        setGoodnote(true);
        count.current = 0;
        setShownote(true);

        setNotific("Registration successful!");

        const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
          process.env.REACT_APP_SERVICE_KEY, {
          method: "post",
          body: JSON.stringify({
            email: process.env.REACT_APP_SERVICE_EMAIL,
            password: process.env.REACT_APP_SERVICE_PASSWORD,
            returnSecureToken: true,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const userToken = await responseToken.json();
        await axios
        .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyFormData2, {
            headers: { Authorization: `Bearer ${userToken.idToken}` },
          }
        )
        .then()
        .catch(() => {
          console.log("(axios) an error occurred")
        });

        console.log("First email sent");

        await axios
        .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyFormData3, {
            headers: { Authorization: `Bearer ${userToken.idToken}` },
          }
        )
        .then()
        .catch(() => {
          console.log("(axios) an error occurred")
        });

        setInputemail("");
        setInputphone("");
        setInputlastname("");
        setInputfirstname("");
        setGphone("");
        setTimeout(todoyen2page, 2000);
        setNophoneerror2(true);
      })
      .catch((error) => {
        console.log(error);
        setShowModal(true);
        setModalContent(getErrorMessage(error));
        if (auth.currentUser) {
          auth.currentUser.delete();
        }
      });
  };

  const handleClick = async () => {
    await signInWithPopup(auth, provider).then(() => {
      navigate("/");
    });
  };

  const completeGoogleRegistration = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    let idToken = await GetToken();
    if (gphone.length >= 6) {
      localStorage.setItem("doyen2email", studentdetails.email);
      var data2: any;

      axios
        .get(`${baseUrl}/registration`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .then((response) => {
          data2 = response.data;
          var emaillist = [];

          for (const [key, value] of Object.entries(data2)) {
            var value1: any;
            value1 = key;
            value1 = value;
            emaillist.push(value1["email"]);
          }
          if (!emaillist.includes(studentdetails.email)) {
            //console.log("Submit to api 2 called.");
            submittoapi2({
              firstname: studentdetails.firstname,
              email: studentdetails.email,
              lastname: studentdetails.lastname,
              phone: "",
              sourceOfDiscovery: "",
            });
            //console.log("Submit to api 2 worked.");
          } else {
            setGoodnote(false);
            count.current = 0;
            setShownote(true);
          }
        });
    } else {
      setNophoneerror2(false);
      setGeterror2("Something wrong with the Phone Number");
    }

    setShownote(false);
  };

  const getGoogleuserinfo = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const inviteCode = urlParams.get("invite");
    const userDetails = await getUserCountry();
    if (tracker === 0) {
      await signInWithPopup(auth, provider).then((data: any) => {
        const userBody = {
          firstname: data?._tokenResponse?.firstName.trim() || "",
          lastname: data?._tokenResponse?.lastName.trim() || "",
          email: data?._tokenResponse?.email.trim() || "",
          phone: data?._tokenResponse?.phoneNumber || "",
          sourceOfDiscovery: "Website",
          newLetter: "false",
          uids: data?.user?.uid.trim() || "",
          Country: userDetails?.countryName,
          showEmail: false,
          inviteCode: inviteCode,
        };
        setStudentdetails(userBody);
        setTracker(1);
        //console.log("Navigating to complete social login")
        navigate("/complete-social-logins", { state: userBody });
      });
    }
  };

  useEffect(() => {
    if (shownote === true) {
      var startTime = new Date().getTime();
      var interval = setInterval(function () {
        if (new Date().getTime() - startTime > 12000) {
          clearInterval(interval);
          return;
        }
        count.current++;
        if (count.current < 7) {
          setShownote(true);
        }
        if (count.current > 8) {
          setShownote(false);
        }
      }, 1000);
    }
  });

  const choicechosen = (value: string) => {
    setMedium(value);
  };

  const navigatehome = () => {
    navigate("/");
  };

  const nameRegex =
    /^\s*[A-Za-z]+(?:['-][A-Za-z]+)?(?: [A-Za-z]+(?:['-][A-Za-z]+)?)*\s*$/;

  const schema: ZodType<FormData> = z
    .object({
      firstname: z
        .string()
        .min(2, "First name must be at least 2 characters long.")
        .max(30, "First name cannot exceed 30 characters.")
        .regex(nameRegex, { message: "Only letters, hyphens, or spaces are allowed." }),
      email: z.string().email("Please enter a valid email address."),
      lastname: z
        .string()
        .min(2, "Last name must be at least 2 characters long.")
        .max(30, "Last name cannot exceed 30 characters.")
        .regex(nameRegex, { message: "Only letters, hyphens, or spaces are allowed." }),
      password: z.string().min(8, "Password must be at least 8 characters.")
        .max(30, "Password too long — max 30 characters."),
      password2: z.string().min(8, "Please confirm your password.").max(30),
    })
    .refine((data) => data.password === data.password2, {
      message: "Passwords do not match. Please retype both passwords.",
      path: ["password2"],
    });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ mode: "onBlur", resolver: zodResolver(schema) });

  const submitData = async (data: FormData) => {
    let idToken = await GetToken();
    setTodisable(true);
    if (inputphone.length < 6) {
      setNophoneerror(false);
      return;
    }

    const body = {
      email: data.email,
    };
    const userResponse = await axios
      .post(`${baseUrl}/getusersbyfield`, body, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      })
      .catch(async (error) => {
        if (
          error.response.data.code === 404 ||
          error.response.data.status === "No matching docs"
        ) {
          // They do not already have an account
          await createUserWithEmailAndPassword(auth, data.email, data.password)
            .then(() => {
              // if (userCredential && auth.currentUser) {
              //   try {
              //     sendEmailVerification(auth.currentUser);
              //   } catch (error) {
              //     console.log(error);
              //     setShowModal(true);
              //     setModalContent(getErrorMessage(error));
              //   }
              // }
              console.log("Reached submit to api")
              submittoapi({
                firstname: data.firstname,
                email: data.email,
                lastname: data.lastname,
                phone: inputphone,
                sourceOfDiscovery: medium || "Others",
              });
            })
            .catch((error: any) => {
              handleSignInError(error);
              signOut(auth)
                .then(() => {
                  localStorage.removeItem("UserId");
                })
                .catch((error) => {
                  console.log(error);
                });
              if (auth.currentUser) {
                auth.currentUser.delete();
              }
              return;
            });
        } else {
          // They do not have an account but we also don't know what the exact error is
          setShowNotification(true);
          setNotification("An error occurred! Please try again.");
          console.log(error.response.data);
          setTodisable(false);
        }
      });
    let doyen: IUserDetails = userResponse?.data?.data[0];
    if (doyen) {
      // They have an account already
      setShowNotification(true);
      setNotification(
        "Account already exists: Please sign in or use Forgot Password"
      );
      setTodisable(false);
      return;
    }
  };

  return (
    <div className="sign-in-container">
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      <Modal show={showNotification} centered={true}>
        <Modal.Body style={{ marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {notification}
            <div style={{ marginTop: "1rem" }}>
              <button
                onClick={handleCloseNotification}
                style={{
                  backgroundColor: "#047E35",
                  color: "white",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.25rem",
                  cursor: "pointer",
                  border: "none",
                  marginRight: "1rem",
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {goodnote ? (
        <>
          <div
            className={shownote ? "text-center shownot" : "text-center hidenot"}
          >
            <div>
              <FontAwesomeIcon
                style={{ display: "inline", fontSize: "25px" }}
                icon={faCheck}
              />
              <h3 style={{ marginLeft: "10px", display: "inline" }}>
                {notific}
              </h3>
            </div>
          </div>

          {shownote ? (
            <>
              <br />
              <br />
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <div
            className={
              shownote ? "text-center shownot2" : "text-center hidenot2"
            }
          >
            <div>
              <FontAwesomeIcon
                style={{ display: "inline", fontSize: "25px" }}
                icon={faXmark}
              />
              <h3 style={{ marginLeft: "10px", display: "inline" }}>
                {notific}
              </h3>
            </div>
          </div>

          {shownote ? (
            <>
              <br />
              <br />
            </>
          ) : (
            <></>
          )}
        </>
      )}

      {givefullview ? (
        <>
          <div>
            <div className="container Enroll-page">
              {moveGoogle ? (
                <>
                  <div style={{ marginTop: "30px" }}>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="ml-[40px]">
                          <img
                            src="../../images/doyenifyAcademy.png"
                            onClick={navigatehome}
                            style={{ cursor: "pointer" }}
                            alt="acadlogo"
                          />
                        </div>

                        <div className="row myfirstcon ">
                          <h4 style={{ fontWeight: "600" }}>
                            Unlock Your Potential:
                          </h4>
                          <h4 style={{ fontWeight: "600" }}>Sign Up Today!</h4>
                          <p>Take the First Step Towards Your Bright Future</p>
                          <img
                            src="../../images/enrolloneimg.png"
                            alt="enrolimg"
                            style={{ width: "100%", height: "241px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="text-center  mt-20">
                          <h2 style={{ color: "#156614" }}>Sign Up</h2>
                          <div className="social-awareness-notice" style={{
    backgroundColor: "#e8f5e9", 
    borderLeft: "4px solid #047E35",
    padding: "10px 15px",
    marginBottom: "20px",
    borderRadius: "4px",
    fontSize: "14px",
    textAlign: "left"
}}>
    <strong>Note:</strong> Your first name and last name will be used on your certificate. You can later update them in your profile settings..
</div>
                          {hideSocialSignup ? (
                            <>
                              {hideTwitterSignup ? (
                                <>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <GoogleLoginButton
                                        onClick={getGoogleuserinfo}
                                        style={{ paddingLeft: "26%" }}
                                        text="Register with Google"
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <TwitterLoginButton
                                        onClick={myHandleTwitter}
                                        style={{ paddingLeft: "26%" }}
                                        text="Register with X"
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div style={{ marginTop: "25px" }}>
                                <div className="row">
                                  <div className="col-md-6">
                                    {/* <LoginSocialGoogle
                                      client_id={housess}
                                      redirect_uri={REDIRECT_URI}
                                      scope="openid profile email"
                                      discoveryDocs="claims_supported"
                                      access_type="offline"
                                      onResolve={({provider, data,
                                      }: IResolveParams) => {
                                        getGoogleuserinfo(data);
                                        }}
                                      onReject={(err) => {
                                        console.log(err);
                                      }}
                                    >
                                      <GoogleLoginButton
                                        style={{ paddingLeft: "17%" }}
                                        text="Register with Google"
                                      />
                                    </LoginSocialGoogle> */}
                                    <GoogleLoginButton
                                      onClick={getGoogleuserinfo}
                                      style={{ paddingLeft: "26%" }}
                                      text="Register with Google"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <TwitterLoginButton
                                      onClick={myHandleTwitter}
                                      style={{ paddingLeft: "26%" }}
                                      text="Register with X"
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        {hideloginform ? (
                          <></>
                        ) : (
                          <>
                            <div className="row secondhalfsecond">
                              <div className="col-4">
                                <hr />
                              </div>
                              <div className="col-4">or Sign Up with</div>
                              <div className="col-4">
                                <hr />
                              </div>
                            </div>
                            <form onSubmit={handleSubmit(submitData)}
                            autoComplete="off"
                            noValidate
                            >
                               {/* Hidden dummy fields to absorb browser autofill */}
                              <input type="text" name="fake_name" autoComplete="off" style={{ display: "none" }} />
                              <input type="email" name="fake_email" autoComplete="off" style={{ display: "none" }} />
                              <input type="password" name="fake_password" autoComplete="off" style={{ display: "none" }} />

                              <div className="row" style={{ margin: "13px" }}>
                                <div className="col-xl-6">
                                  <div>
                                    <h3
                                      style={{
                                        fontSize: "16px",
                                        width: "220px",
                                      }}
                                    >
                                      What’s your first name?
                                      <span
                                        style={{
                                          color: "#FF0000",
                                          paddingLeft: "4px",
                                          fontSize: "20px",
                                        }}
                                      >
                                        *
                                      </span>
                                    </h3>

                                    <input
                                      {...register("firstname")}
                                      autoComplete="new-name"
                                      className="textinputs"
                                      value={inputfirstname}
                                      type="text"
                                      onChange={(e) =>
                                        setInputfirstname(e.target.value.trim())
                                      }
                                      required
                                    />

                                    {errors.firstname && (
                                      <p className="errortext">
                                        {errors.firstname.message}
                                      </p>
                                    )}

                                    <h3
                                      style={{
                                        fontSize: "16px",
                                        marginTop: "20px",
                                      }}
                                    >
                                      What’s your last name?
                                      <span
                                        style={{
                                          color: "#FF0000",
                                          paddingLeft: "4px",
                                          fontSize: "20px",
                                        }}
                                      >
                                        *
                                      </span>
                                    </h3>

                                    <input
                                      {...register("lastname")}
                                      autoComplete="new-name"
                                      className="textinputs"
                                      value={inputlastname}
                                      type="text"
                                      onChange={(e) =>
                                        setInputlastname(e.target.value.trim())
                                      }
                                      required
                                    />
                                    {errors.lastname && (
                                      <p className="errortext">
                                        {errors.lastname.message}
                                      </p>
                                    )}

                                    <h3
                                      style={{
                                        fontSize: "16px",
                                        marginTop: "15px",
                                      }}
                                    >
                                      Email
                                      <span
                                        style={{
                                          color: "#FF0000",
                                          paddingLeft: "4px",
                                          fontSize: "20px",
                                        }}
                                      >
                                        *
                                      </span>
                                    </h3>
                                    <input
                                      {...register("email")}
                                      autoComplete="new-email"
                                      className="textinputs"
                                      value={inputemail}
                                      type="email"
                                      name="email"
                                      onChange={(e) =>
                                        setInputemail(e.target.value.trim())
                                      }
                                      required
                                    />

                                    {errors.email && (
                                      <p className="errortext">
                                        {errors.email.message}
                                      </p>
                                    )}

                                    <h3
                                      style={{
                                        fontSize: "16px",
                                        marginTop: "27px",
                                        width: "220px",
                                      }}
                                    >
                                      How did you hear about us?
                                    </h3>
                                    <div style={{ marginTop: "10px" }}>
                                      <input
                                        id="Friends"
                                        type="radio"
                                        name="somename"
                                        checked={medium === "Friends"}
                                        autoComplete="new-medium"
                                        onChange={(e) => {}}
                                        onClick={() => {
                                          choicechosen("Friends");
                                        }}
                                      />
                                      <span style={{ marginLeft: "10px" }}>
                                        Friends
                                      </span>
                                      <br />
                                    </div>

                                    <div style={{ marginTop: "10px" }}>
                                      <input
                                        id="Socialmedia"
                                        type="radio"
                                        name="somename"
                                        checked={medium === "Social Media"}
                                        onChange={(e) => {}}
                                        onClick={() => {
                                          choicechosen("Social Media");
                                        }}
                                      />
                                      <span style={{ marginLeft: "10px" }}>
                                        Social Media
                                      </span>
                                      <br />
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                      <input
                                        id="Webinar"
                                        type="radio"
                                        name="somename"
                                        checked={medium === "Webinar"}
                                        onChange={(e) => {}}
                                        onClick={() => {
                                          choicechosen("Webinar");
                                        }}
                                      />
                                      <span style={{ marginLeft: "10px" }}>
                                        Webinar
                                      </span>
                                      <br />
                                    </div>
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <input
                                        id="Website"
                                        type="radio"
                                        name="somename"
                                        checked={medium === "Website"}
                                        onChange={(e) => {}}
                                        onClick={() => {
                                          choicechosen("Website");
                                        }}
                                      />
                                      <span style={{ marginLeft: "10px" }}>
                                        Website
                                      </span>
                                      <br />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-xl-6">
                                  <div>
                                    <h3
                                      style={{
                                        fontSize: "16px",
                                        marginTop: "0px",
                                        width: "220px",
                                      }}
                                    >
                                      Your valid phone number?
                                      <span
                                        style={{
                                          color: "#FF0000",
                                          paddingLeft: "4px",
                                          fontSize: "20px",
                                        }}
                                      >
                                        *
                                      </span>
                                    </h3>

                                    <div
                                      className={
                                        nophoneerror
                                          ? "textinputsp"
                                          : "textinputs2p"
                                      }
                                    >
                                      <PhoneInput
                                        country={"ng"}
                                        value={inputphone}
                                        onChange={(inputphone) =>
                                          setInputphone(inputphone)
                                        }
                                        isValid={(value, country: any) => {
                                          /* eslint-disable no-useless-escape */
                                          if (
                                            value.match(
                                              /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                            )
                                          ) {
                                            return (
                                              "Invalid value: " +
                                              value +
                                              ", " +
                                              country.name
                                            );
                                            /* eslint-disable no-useless-escape */
                                          } else if (
                                            value.match(
                                              /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                            )
                                          ) {
                                            return false;
                                          } else {
                                            return true;
                                          }
                                        }}
                                      />
                                    </div>
                                    {nophoneerror ? (
                                      <></>
                                    ) : (
                                      <>
                                        <p
                                          className={
                                            nophoneerror
                                              ? "errortext3"
                                              : "errortext2"
                                          }
                                        >
                                          Phone number seems incorrect.
                                        </p>
                                      </>
                                    )}

                                    <h3
                                      className="flex"
                                      style={{
                                        fontSize: "16px",
                                        marginTop: "20px",
                                        marginBottom: "0",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      Day and Month of Birth (Optional)
                                      {/* <span  >  </span>  
                                      <span>  */}
                                      <span
                                        style={{
                                          marginLeft: "4px",
                                          position: "relative",
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "relative",
                                            display: "inline-block",
                                          }}
                                          onMouseEnter={() =>
                                            setshowTooltip(true)
                                          }
                                          onMouseLeave={() =>
                                            setshowTooltip(false)
                                          }
                                        >
                                          <img
                                            src="../../images/question.png"
                                            alt="Info"
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                              cursor: "pointer",
                                            }}
                                          />
                                          {showTooltip && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: "25px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                backgroundColor: "#333",
                                                color: "#fff",
                                                padding: "5px ",
                                                borderRadius: "5px",
                                                fontSize: "12px",
                                                whiteSpace: "normal",
                                                wordWrap: "break-word",
                                                zIndex: 1,
                                                boxShadow:
                                                  "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                width: "300px",

                                                textAlign: "center",
                                                lineHeight: "0.75",
                                              }}
                                            >
                                              Your birth day and month is
                                              optionally collected primarily for
                                              customer acquaintance purposes.
                                              This information is not used for
                                              any other reasons.
                                            </div>
                                          )}
                                        </div>
                                      </span>
                                    </h3>

                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "8px",
                                        alignItems: "center",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <input
                                        type="number"
                                        min="1"
                                        max="31"
                                        placeholder="Day"
                                        value={inputDay}
                                        onChange={(e) =>
                                          setInputDay(e.target.value)
                                        }
                                        className="textinputs"
                                        style={{
                                          width: "55px",
                                          padding: "5px",
                                        }}
                                      />
                                      <select
                                        value={inputMonth}
                                        onChange={(e) =>
                                          setInputMonth(e.target.value)
                                        }
                                        className="textinputs"
                                        style={{
                                          padding: "5px",
                                        }}
                                      >
                                        <option value="">Select Month</option>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      marginBottom: "20px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <div className="textinputbody2">
                                      <FontAwesomeIcon
                                        className="loginicon2"
                                        icon={faLock}
                                      />
                                      <input
                                        type={
                                          hidepassword ? "password" : "text"
                                        }
                                        autoComplete="new-password"
                                        className="textinputs22"
                                        {...register("password")}
                                        placeholder="Enter your password"
                                        value={password}
                                        onChange={(e) =>
                                          setPassword(e.target.value)
                                        }
                                        required
                                      ></input>
                                      <div
                                        onClick={() => {
                                          setHidepassword(!hidepassword);
                                        }}
                                      >
                                        {hidepassword ? (
                                          <>
                                            <FontAwesomeIcon
                                              className="loginicon"
                                              icon={faEye}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <FontAwesomeIcon
                                              className="loginicon"
                                              icon={faEyeSlash}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {errors.password && (
                                      <p className="errortext">
                                        {errors.password.message}
                                      </p>
                                    )}
                                  </div>

                                  <div style={{ marginBottom: "10px" }}>
                                    <div className="textinputbody2">
                                      <FontAwesomeIcon
                                        className="loginicon2"
                                        icon={faLock}
                                      />
                                      <input
                                        type={
                                          hidepassword2 ? "password" : "text"
                                        }
                                        autoComplete="new-password"
                                        className="textinputs22"
                                        {...register("password2")}
                                        placeholder="Confirm password"
                                        value={password2}
                                        onChange={(e) =>
                                          setPassword2(e.target.value)
                                        }
                                        required
                                      ></input>
                                      <div
                                        onClick={() => {
                                          setHidepassword2(!hidepassword2);
                                        }}
                                      >
                                        {hidepassword2 ? (
                                          <>
                                            <FontAwesomeIcon
                                              className="loginicon"
                                              icon={faEye}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <FontAwesomeIcon
                                              className="loginicon"
                                              icon={faEyeSlash}
                                            />
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    {errors.password2 && (
                                      <p className="errortext">
                                        {errors.password2.message}
                                      </p>
                                    )}
                                  </div>
                                  <p style={{ color: "#FF0000" }}>{geterror}</p>

                                  {/* <Button
                                    type="submit"
                                    disabled={todisable}
                                    className="formbtn"
                                    variant="success"
                                  >
                                    {todisable ? `Creating your account...` : `Sign Up`}
                                  </Button> */}
                                  <button
                                  type="submit"
                                  disabled={todisable}
                                  // variant="success"
                                    style={{
                                      backgroundColor: "#047E35",
                                      color: "white",
                                      padding: "0.5rem 1rem",
                                      borderRadius: "0.25rem",
                                      cursor: "pointer",
                                      border: "none",
                                      marginRight: "1rem",
                                    }}
                                  >
                                    {todisable ? `Creating your account...` : `Sign Up`}
                                  </button>
                                  <br />

                                  <br />
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={newsLetter}
                                      onChange={(e) => {}}
                                      onClick={subscribetonewsletter}
                                    />{" "}
                                    <span>
                                      Tick to subscribe to our NewsLetter
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Have an Account?{" "}
                                    <p
                                      style={{
                                        display: "inline",
                                        cursor: "pointer",
                                        color: "#308f42",
                                      }}
                                      onClick={toSignIn}
                                    >
                                      Sign In
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </>
                        )}

                        <br />
                        <br />
                      </div>
                    </div>
                  </div>
                  {/* google section */}
                </>
              ) : (
                <>
                  {ifGoogle ? (
                    <>
                      <div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="row myfirstcon">
                              <h4 style={{ fontWeight: "600" }}>
                                Unlock Your Potential:
                              </h4>
                              <h4 style={{ fontWeight: "600" }}>
                                Sign Up Today!
                              </h4>
                              <p>
                                Take the First Step Towards Your Bright Future
                              </p>
                              <img
                                src="../../images/enrolloneimg.png"
                                alt="enrolimg"
                                style={{ width: "100%", height: "241px" }}
                              />
                            </div>
                          </div>
                          <div className="col-md-8">
                            {showLoginbtn ? (
                              <></>
                            ) : (
                              <>
                                <form
                                  style={{ marginTop: "100px" }}
                                  onSubmit={completeGoogleRegistration}
                                >
                                  <div>
                                    <h2>
                                      Please fill in the below to complete the
                                      Registration
                                    </h2>
                                  </div>

                                  <div
                                    className={
                                      nophoneerror2
                                        ? "textinputsp"
                                        : "textinputs2p"
                                    }
                                  >
                                    <PhoneInput
                                      country={"ng"}
                                      value={gphone}
                                      onChange={(gphone) => setGphone(gphone)}
                                      isValid={(value, country: any) => {
                                        /* eslint-disable no-useless-escape */
                                        if (
                                          value.match(
                                            /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                          )
                                        ) {
                                          return (
                                            "Invalid value: " +
                                            value +
                                            ", " +
                                            country.name
                                          );
                                          /* eslint-disable no-useless-escape */
                                        } else if (
                                          value.match(
                                            /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                          )
                                        ) {
                                          return false;
                                        } else {
                                          return true;
                                        }
                                      }}
                                    />
                                  </div>

                                  <p style={{ color: "#FF0000" }}>
                                    {geterror2}
                                  </p>
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={newsLetter}
                                      onChange={(e) => {}}
                                      onClick={subscribetonewsletter}
                                    />{" "}
                                    <span>
                                      Tick to subscribe to our NewsLetter
                                    </span>
                                  </div>
                                  <button
                                    className="btn btn-success"
                                    style={{ marginBottom: "20px" }}
                                    type="submit"
                                  >
                                    Click to Complete
                                  </button>
                                </form>
                              </>
                            )}

                            {showLoginbtn ? (
                              <>
                                <div style={{ marginTop: "100px" }}>
                                  <h3 style={{ textAlign: "center" }}>
                                    You have already registered
                                  </h3>
                                  <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        border: "1px solid #156614",
                                        padding: "7px",
                                        cursor: "pointer",
                                      }}
                                      onClick={handleClick}
                                    >
                                      <img
                                        style={{
                                          marginLeft: "30%",
                                          height: "25px",
                                        }}
                                        src="../../images/Google.png"
                                        alt="acadlogo"
                                      />
                                      <h5
                                        style={{
                                          paddingLeft: "12px",
                                          paddingTop: "4px",
                                          color: "#696969",
                                        }}
                                      >
                                        Click, to Login with Google
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {ifTwitter ? (
                    <>
                      {showTwitterLogin ? (
                        <>
                          <div>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="row myfirstcon">
                                  <h4 style={{ fontWeight: "600" }}>
                                    Unlock Your Potential:
                                  </h4>
                                  <h4 style={{ fontWeight: "600" }}>
                                    Sign Up Today!
                                  </h4>
                                  <p>
                                    Take the First Step Towards Your Bright
                                    Future
                                  </p>
                                  <img
                                    src="../../images/enrolloneimg.png"
                                    alt="enrolimg"
                                    style={{ width: "100%", height: "241px" }}
                                  />
                                </div>
                              </div>
                              <div className="col-md-8">
                                <div className="row">
                                  <div className="col-md-8">
                                    <div style={{ marginTop: "120px" }}>
                                      <div style={{ marginTop: "100px" }}>
                                        <div>
                                          <div
                                            style={{
                                              display: "flex",
                                              border: "1px solid #156614",
                                              padding: "7px",
                                              cursor: "pointer",
                                            }}
                                            // onClick={SignInWithTwitter}
                                          >
                                            <img
                                              style={{
                                                marginLeft: "15%",
                                                height: "25px",
                                              }}
                                              src="../../images/twitter.png"
                                              alt="acadlogo"
                                            />
                                            <h5
                                              style={{
                                                paddingLeft: "12px",
                                                paddingTop: "4px",
                                                color: "#696969",
                                              }}
                                            >
                                              Click, to Complete Registration
                                            </h5>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-4"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="row myfirstcon">
                                  <h4 style={{ fontWeight: "600" }}>
                                    Unlock Your Potential:
                                  </h4>
                                  <h4 style={{ fontWeight: "600" }}>
                                    Sign Up Today!
                                  </h4>
                                  <p>
                                    Take the First Step Towards Your Bright
                                    Future
                                  </p>
                                  <img
                                    src="../../images/enrolloneimg.png"
                                    alt="enrolimg"
                                    style={{ width: "100%", height: "241px" }}
                                  />
                                </div>
                              </div>
                              <div className="col-md-8">
                                {showLoginbtn ? (
                                  <></>
                                ) : (
                                  <>
                                    <form
                                      style={{ marginTop: "100px" }}
                                      onSubmit={getTwitterSignupdata}
                                    >
                                      <div>
                                        <h2>
                                          Please fill in the below to complete
                                          the Registration
                                        </h2>
                                      </div>
                                      <div className="form-row">
                                        <div className="row">
                                          <div className="col-md-6 mb-3">
                                            <label htmlFor="validationServer01">
                                              Firstname
                                              <span
                                                style={{ color: "#FF0000" }}
                                              >
                                                *
                                              </span>
                                            </label>
                                            <input
                                              type="text"
                                              className={
                                                twitternofirstnameerror
                                                  ? "form-control is-valid"
                                                  : "form-control is-invalid"
                                              }
                                              value={twitterFirstname}
                                              onChange={(e) => {
                                                setTwitterFirstname(
                                                  e.target.value
                                                );
                                              }}
                                              id="validationServer01"
                                              placeholder="Your first name"
                                            />
                                            {twitternofirstnameerror ? (
                                              <></>
                                            ) : (
                                              <>
                                                <p style={{ color: "#FF0000" }}>
                                                  Something wrong with value
                                                  inputted
                                                </p>
                                              </>
                                            )}
                                          </div>
                                          <div className="col-md-6 mb-3">
                                            <label htmlFor="validationServer02">
                                              E-mail Address
                                              <span
                                                style={{ color: "#FF0000" }}
                                              >
                                                *
                                              </span>
                                            </label>
                                            <input
                                              type="email"
                                              className={
                                                twitternoemailerror
                                                  ? "form-control is-valid"
                                                  : "form-control is-invalid"
                                              }
                                              value={twitterEmail}
                                              onChange={(e) => {
                                                setTwitterEmail(e.target.value);
                                              }}
                                              id="validationServer02"
                                              placeholder="Your email"
                                            />
                                            {twitternoemailerror ? (
                                              <></>
                                            ) : (
                                              <>
                                                <p style={{ color: "#FF0000" }}>
                                                  Something wrong with value
                                                  inputted
                                                </p>
                                              </>
                                            )}
                                          </div>
                                        </div>

                                        <div className="row">
                                          <div className="col-md-6">
                                            <div className="mb-3">
                                              <label htmlFor="validationServer01">
                                                lastname
                                                <span
                                                  style={{ color: "#FF0000" }}
                                                >
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="text"
                                                className={
                                                  twitternolastnameerror
                                                    ? "form-control is-valid"
                                                    : "form-control is-invalid"
                                                }
                                                id="validationServer01"
                                                value={twitterLastname}
                                                onChange={(e) => {
                                                  setTwitterLastname(
                                                    e.target.value
                                                  );
                                                }}
                                                placeholder="Your last name"
                                              />
                                              {twitternolastnameerror ? (
                                                <></>
                                              ) : (
                                                <>
                                                  <p
                                                    style={{ color: "#FF0000" }}
                                                  >
                                                    Something wrong with value
                                                    inputted
                                                  </p>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                          <div className="col-md-6 mb-3">
                                            <label htmlFor="validationServer03">
                                              Phone Number
                                              <span
                                                style={{ color: "#FF0000" }}
                                              >
                                                *
                                              </span>
                                            </label>

                                            <div
                                              className={
                                                twitternophoneerror
                                                  ? "textinputsp"
                                                  : "textinputs2p"
                                              }
                                            >
                                              <PhoneInput
                                                country={"ng"}
                                                value={twitterPhone}
                                                onChange={(twitterPhone) =>
                                                  setTwitterPhone(twitterPhone)
                                                }
                                                isValid={(
                                                  value,
                                                  country: any
                                                ) => {
                                                  /* eslint-disable no-useless-escape */
                                                  if (
                                                    value.match(
                                                      /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                                    )
                                                  ) {
                                                    return (
                                                      "Invalid value: " +
                                                      value +
                                                      ", " +
                                                      country.name
                                                    );
                                                    /* eslint-disable no-useless-escape */
                                                  } else if (
                                                    value.match(
                                                      /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                                    )
                                                  ) {
                                                    return false;
                                                  } else {
                                                    return true;
                                                  }
                                                }}
                                              />
                                            </div>
                                            {twitternophoneerror ? (
                                              <></>
                                            ) : (
                                              <>
                                                <p
                                                  className={
                                                    twitternophoneerror
                                                      ? "errortext3"
                                                      : "errortext2"
                                                  }
                                                >
                                                  something Wrong with the Phone
                                                  Number
                                                </p>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          marginBottom: "10px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={newsLetter}
                                          onChange={(e) => {}}
                                          onClick={subscribetonewsletter}
                                        />{" "}
                                        <span>
                                          Tick to subscribe to our NewsLetter
                                        </span>
                                      </div>
                                      <button
                                        type="submit"
                                        className="btn btn-success"
                                      >
                                        Submit form
                                      </button>
                                    </form>
                                  </>
                                )}

                                {showLoginbtn ? (
                                  <>
                                    <div style={{ marginTop: "100px" }}>
                                      <h3 style={{ textAlign: "center" }}>
                                        You have already registered
                                      </h3>
                                      <div>
                                        <div
                                          style={{
                                            display: "flex",
                                            border: "1px solid #156614",
                                            padding: "7px",
                                            cursor: "pointer",
                                          }}
                                          onClick={handleClick}
                                        >
                                          <img
                                            style={{
                                              marginLeft: "30%",
                                              height: "25px",
                                            }}
                                            src="../../images/Google.png"
                                            alt="acadlogo"
                                          />
                                          <h5
                                            style={{
                                              paddingLeft: "12px",
                                              paddingTop: "4px",
                                              color: "#696969",
                                            }}
                                          >
                                            Click, to Login with Google
                                          </h5>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}

                  {/* still adding github */}
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SignUp;
